export const pondType = [
  { text: "Ao nuôi", value: "Ao nuôi" },
  { text: "Ao xử lý", value: "Ao xử lý" }
];

export const pondStatus = [
  { text: "Hoạt động", value: 1 },
  { text: "Không hoạt động", value: 0 },
  { text: "Không tồn tại", value: 2 }
];
export const accountZaloStatus = [
  { text: "Đã gửi nhiệm vụ", value: 0 },
  { text: "Chưa gửi nhiệm vụ", value: 1 }
];
export const classIsActive = [
  { text: "Deactive", value: 0 },
  { text: "Active", value: 1 }

];
export const levelBabiPro= [
  { text: "Level 1", value: "Level 1" },
  { text: "Level 2", value: "Level 2" },
  { text: "Level 3", value: "Level 3" },
  { text: "Level R1", value: "Level R1" },
  { text: "Level R2", value: "Level R2" }
];
export const teachersBabiPro= [
  { text: "Việt nam - Việt nam", value: 1 },
  { text: "Việt nam - Nước ngoài", value: 2 },
  { text: "Việt nam - Phi", value: 3 }
];
export const degreeBabiPro= [
  { text: "Basic", value: "Basic" },
  { text: "Advanced", value: "Advanced" }
];
export const dateteachingBabiPro= [
  { text: "Thứ 2", value: 2 },
  { text: "Thứ 3", value: 3 },
  { text: "Thứ 4", value: 4 },
  { text: "Thứ 5", value: 5 },
  { text: "Thứ 6", value: 6 },
  { text: "Thứ 7", value: 7 },
  { text: "Chủ nhật", value: 8 },
];
export const materialStatus = [
  { text: "Đang sử dụng", value: 1 },
  { text: "Ngừng sử dụng", value: 0 }
];

export const areaStatus = [
  { text: "Đang sử dụng", value: 1 },
  { text: "Ngừng sử dụng", value: 0 }
];

export const fixedAssetsStatus = [
  { text: "Đang sử dụng", value: 1 },
  { text: "Ngừng sử dụng", value: 0 },
  { text: "Thanh lý tài sản", value: 2 },
  { text: "Đã xuất kho đi sửa", value: 3 }
];